import React, { Fragment } from 'react';
import { css } from '@emotion/css';
import { FlexBox, colors } from '@cimpress/react-components';

import Block from './block';

const FlexExampleOne = () => (
  <Fragment>
    <h5>Example of Centered FlexBox</h5>
    <FlexBox
      className={css`
        background-color: ${colors.warning.base};
        height: 150px;
      `}
      alignItems="center"
      justifyContent="center"
    >
      <Block />
      <Block />
      <Block />
      <Block />
      <Block />
    </FlexBox>
  </Fragment>
);

export default FlexExampleOne;
